import cooperationCasesData from "../cooperationCases/data";
import banner from "./imgs/bg.png";

export const channelCardList = cooperationCasesData.mainCaseList
  .sort((a, b) => {
    // 按照日期降序排列
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  })
  .map((item, index) => ({
    ...item,
    date: item.date.replaceAll("/", "-"),
    desc: item.title,
    vertical: index === 0 || index === 3,
    position: index === 0 ? "bottom" : index === 3 ? "top" : undefined,
  }));

export const cooperationTexts = [
  "申请成为「市场」合作伙伴",
  "申请成为「数字服务商」合作伙伴",
  "申请成为「代理商」合作伙伴",
];

const data = {
  p1: {
    title: "生态合作",
    subtitle: "携手共赢，未来已来",
    showBtn: false,
    banner
  },
  p2: {
    title: "战略合作",
  },
  p3: {
    title: "生态伙伴",
  },
  p5: {
    title: ["携手共赢", "开启数字员工无限可能"],
    steps: [
      "点击「成为伙伴」按钮，提交合作意愿",
      "确定所需合作类型，完成资质评估审核",
      "双方签署合作协议，成为合作伙伴",
    ],
    buttonTexts: cooperationTexts,
  },
};

export default data;